<template>
  <div>
    <p-date v-if="meta.type === questionFormPropertyTypes.Date" v-model="myValue" :style="{width:meta.width}" :meta="meta" :rule-fuc="ruleFuc" />
    <p-uploader v-if="meta.type === questionFormPropertyTypes.File" :meta="meta" :style="{width:meta.width}" :validate="validate[meta.name]" :file-list="uploadFiles[meta.name] || []" @uploadOrDelete="(val) => {uploadOrDelete(val, meta)}" @uploaded="(val) => {uploaded(val, meta)}" />
    <component
      :is="meta | getComponentName"
      v-else-if="mOtherShow(meta)"
      :key="meta.name"
      v-model="myValue"
      :rules="ruleFuc(meta)"
      :label="meta.label"
      :items="meta.options"
      item-text="label"
      item-value="id"
      :style="{width:meta.width}"
      :multiple="meta.multiple"
      :required="meta.required"
      @change="(val) => {componentChange(val, meta)}"
    >
      <template v-if="meta.type === questionFormPropertyTypes.Radio">
        <v-radio v-for="o in meta.options" :key="o.id" validate-on-blur :label="o.label" :value="o.id" />
      </template>
      <template v-if="meta.type === questionFormPropertyTypes.Checkbox">
        <v-checkbox v-for="o in meta.options" :key="o.id" v-model="myValue" multiple :label="o.label" :value="o.id" />
      </template>
      <template v-if="meta.type === questionFormPropertyTypes.Select">
        <v-checkbox v-for="o in meta.options" :key="o.id" v-model="myValue" multiple :label="o.label" :value="o.id" />
      </template>
    </component>
  </div>
</template>
<script>
import { VRadioGroup, VTextarea, VTextField, VSelect } from 'vuetify/lib'
import PDate from './date'
import PUploader from './file'
import {
  FormPropertyTypes
} from '../forminfo/YPApplicationForm'
export default {
  components: {
    VRadioGroup,
    VTextarea,
    VTextField,
    VSelect,
    PDate,
    PUploader
  },
  filters: {
    getComponentName(meta) {
      switch (meta.type) {
        case FormPropertyTypes.Radio:
          return 'VRadioGroup'
        case FormPropertyTypes.Checkbox:
          return 'VRadioGroup'
        case FormPropertyTypes.Textarea:
          return 'VTextarea'
        case FormPropertyTypes.Textfield:
          return 'VTextField'
        case FormPropertyTypes.Select:
          return 'VSelect'
      }
    }
  },
  props: {
    meta: {
      type: Object,
      default: () => {}
    },
    value: {
      type: String,
      default: ''
    },
    ruleFuc: {
      type: Function,
      default: () => {}
    },
    fieldType: {
      type: Object,
      default: () => {}
    },
    allShowOther: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      myValue: this.value,
      questionFormPropertyTypes: FormPropertyTypes
    }
  },
  watch: {
    value(newVal) {
      this.myValue = newVal
    },
    myValue(newVal) {
      this.$emit('input', newVal)
    }
  },
  methods: {
    mOtherShow(meta) {
      return (Object.values(this.allShowOther).includes(meta.id) && meta.id.endsWith('_other')) || !meta.id.endsWith('_other')
    },
    componentChange(val, p) {
      const types = [this.questionFormPropertyTypes.Radio, this.questionFormPropertyTypes.Select]
      if (types.includes(p.type)) { this.$set(this.allShowOther, p.id, val + '_other') }
      console.log(this.allShowOther)
    }
  }
}
</script>
